<template>
  <div class="site-popup" :class="showSitePopup ? 'active' : 'passive'" @click="hideModal">
    <div class="inner lines-bg">
      <h3>Heads Up!</h3>
      <p>{{ showSitePopup }}</p>
      <button class="button magenta pulse" @click="hideModal">Dismiss</button>
      <button class="close" @click="hideModal">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" :fill="'#000'" class="bi bi-x" viewBox="0 0 16 16">
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'SitePopup',
  computed: {
    ...mapState(['showSitePopup'])
  },
  methods: {
    ...mapMutations([ 'setShowSitePopup' ]),
    hideModal() {
      this.setShowSitePopup(false)
      document.body.style.overflow = 'auto'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/_variables';

.site-popup {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 101;
  background: rgba(#000, .8);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 16px;

  &.passive {
    display: none;
  }

  .inner {
    position: relative;
    width: 100%;
    max-width: 560px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 0px 10px rgba(#000, .5);
    background-position: initial;
    text-align: center;
    border-radius: 4px;
    padding: 20px 16px;
    gap: 12px;

    h3 {
      font-family: $pie;
      color: $magenta;
      text-transform: uppercase;
      font-size: 32px;
    }

    button.magenta {
      height: 40px;
    }

    button.close {
      position: absolute;
      top: 10px;
      right: 8px;
      width: fit-content;
      padding: unset;
      height: 24px;
      background: unset;

      &:hover {
        background: unset;
      }
    }
  }
}

</style>